import { VISITED_PAGES_VALUES } from 'common/domain/constants';

class visitedPagesService {

  constructor() {
    this.counterVisitedPages = 0;
  }

  getCounterVisitedPages() {
    return this.counterVisitedPages;
  }

  shouldExitApp() {    
    return this.counterVisitedPages <= VISITED_PAGES_VALUES.INDEX_INIT_PAGE;
  }

  addPageToCounter() {    
    this.counterVisitedPages += VISITED_PAGES_VALUES.VALUE_TO_ADD;
  }

  subtractPageToCounter() {
    this.counterVisitedPages -= VISITED_PAGES_VALUES.VALUE_TO_SUBTRACT;
  }

}

export default visitedPagesService;


// WEBPACK FOOTER //
// ./client/app/common/services/visitedPages.service.js